import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getMonthName } from "../utils";
import { CalendarFilters } from "./CalendarFilters";

export const CalendarHeader = ({
  currentDate,
  onMonthChange,
  filterType,
  filterValue,
  filterOptions,
  onFilterTypeChange,
  onFilterValueChange,
  onClear,
  events,
}) => {
  const monthName = getMonthName(currentDate);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        px: 1.5,
        py: 1,
        bgcolor: "white",
        borderRadius: "12px",
        boxShadow: "0 1px 2px rgba(15,23,42,0.05), 0 8px 20px rgba(15,23,42,0.06)",
        flexWrap: "wrap",
      }}
    >
      <Box display="flex" alignItems="center" gap={0.5} minWidth={0}>
        <IconButton
          onClick={() => onMonthChange(-1)}
          size="small"
          sx={{ color: "#374151" }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
        </IconButton>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 15,
            color: "#111",
            letterSpacing: "-0.03em",
            textTransform: "capitalize",
            minWidth: 148,
            textAlign: "center",
          }}
        >
          {monthName.toLowerCase()}
        </Typography>
        <IconButton
          onClick={() => onMonthChange(1)}
          size="small"
          sx={{ color: "#374151" }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Box>

      <CalendarFilters
        filterType={filterType}
        filterValue={filterValue}
        filterOptions={filterOptions}
        onFilterTypeChange={onFilterTypeChange}
        onFilterValueChange={onFilterValueChange}
        onClear={onClear}
        events={events}
      />
    </Box>
  );
};
